import iamApi from "../../api/IamApi";
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { updatePayableSessionLanguage } from "api/IamApi/entities/ezpay";
import { useDispatch, useSelector } from "react-redux";
import { getDomain } from "utilities/helper";
import { mapUiLanguageToSessionLanguage } from "utilities/helper";
import { IPayableSessionData } from "types/payableSession";
import { setPayableSession } from "actions/payableSessionActions";
import { getPayableSession } from "selectors/payableSession";
import { Spinner } from "kubra-ux-forge";

export const PayableSessionProvider = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const payableSession = useSelector(getPayableSession);
  const [applePaySession, setApplePaySession] = useState(null);

  const payableLogin = (payableSession: IPayableSessionData) => {
    dispatch(setPayableSession(payableSession));
  };

  useEffect(() => {
    // TODO: consider handling the direct landing session scenarios here instead of later in the child components?
    // That is, we can check the route and if it's a direct landing URL then instead of calling
    // the regular /session/payable endpoint, it should call the direct landing endpoint to validate
    // the passed parameters and get the session that way.
    // We can handle all sorts of direct landing here (CSR, non-CSR, recent payments etc.)

    const domain = getDomain();

    iamApi.ezpay
      .getPayableFromSession(domain)
      .then((response) => {
        payableLogin(response);
      })
      .catch((error) => {
        console.log(error);
        dispatch(setPayableSession(undefined));
      })
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const uiLanguage = mapUiLanguageToSessionLanguage(i18n.language);

    if (payableSession && uiLanguage !== payableSession.language) {
      updatePayableSessionLanguage(uiLanguage)
        .then(() =>
          setPayableSession({
            ...payableSession,
            language: uiLanguage,
          })
        )
        .catch(() => {
          console.error(
            "Unexpected error hapenned while updating user's selected language in the session"
          );
        });
    }
  }, [payableSession, i18n.language]);

  // Allow the payable session API call to finish before rendering child routes
  // as otherwise any child route that depends on the payable session will redirect
  // to the index page in its absence.
  if (isLoading) {
    return (
      <div className="validate-frame">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <Spinner size="large" variant="primary" />
        </div>
      </div>
    );
  }

  // TODO: review if the appleyPaySession/setApplePaySession need to
  // remain in the outlet context or can they be moved to Redux?
  return (
    <Outlet
      context={{
        applePaySession,
        setApplePaySession,
      }}
    />
  );
};

export default PayableSessionProvider;
